import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import moment from 'moment';
import { PostPlatformPreview } from 'components';

var ContentPostPreview = /*#__PURE__*/function (_Component) {
  _inherits(ContentPostPreview, _Component);

  var _super = _createSuper(ContentPostPreview);

  function ContentPostPreview(props) {
    var _this;

    _classCallCheck(this, ContentPostPreview);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "translatePost", function (post) {
      var images = post !== null && post !== void 0 && post.S3Files && !!post.S3Files.length ? post.S3Files.map(function (file) {
        return file.fullyQualifiedUrl;
      }) : [];
      var postType = 'textPost';

      if (post.linkUrl) {
        postType = 'linkPost';
      } else if (post.videoUrl) {
        postType = 'videoPost';
      } else if (images.length) {
        postType = 'imagePost';
      }

      var messagesData = {};
      post.SocialAccountPostTemplates && !!post.SocialAccountPostTemplates.length ? post.SocialAccountPostTemplates.forEach(function (sap) {
        messagesData[sap.accountPlatform.split(' ')[0].toLowerCase()] = sap.message;
      }) : null;

      _this.setState({
        messages: _objectSpread({
          global: post.message
        }, messagesData),
        images: images,
        postType: postType
      });
    });

    _this.state = {
      images: [],
      messages: {
        global: ''
      },
      postType: 'textPost'
    };
    return _this;
  }

  _createClass(ContentPostPreview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.post) {
        this.translatePost(this.props.post);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.post.id !== this.props.post.id) {
        this.translatePost(this.props.post);
      }
    }
  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _React$createElement;

      var post = this.props.post;
      var videos = post !== null && post !== void 0 && post.videoUrl && this.state.postType === 'videoPost' ? [this.state.videoUrl] : [];
      return /*#__PURE__*/React.createElement("div", {
        id: "content-post-preview-test"
      }, /*#__PURE__*/React.createElement(PostPlatformPreview, (_React$createElement = {
        style: {
          margin: '0 auto',
          maxWidth: 527,
          paddingTop: 8,
          paddingBottom: 8
        },
        images: this.state.images,
        messages: this.state.messages,
        link: post !== null && post !== void 0 && post.linkUrl ? post.linkUrl : null,
        linkTitle: post !== null && post !== void 0 && post.linkTitle ? "".concat(post.linkTitle.slice(0, 60), "...") : '',
        linkCaption: this.state.postType === 'linkPost' && post.linkUrl ? post.linkUrl.split('//')[1].split('/')[0] : '',
        postDate: null,
        postType: this.state.postType
      }, _defineProperty(_React$createElement, "style", {
        marginTop: 20
      }), _defineProperty(_React$createElement, "videos", post !== null && post !== void 0 && post.videoUrl ? [post.videoUrl] : []), _React$createElement)));
    }
  }]);

  return ContentPostPreview;
}(Component);

export default ContentPostPreview;